import { createBrowserRouter } from "react-router-dom";

import Route from "./route";
import PrivateRoute from "./privateRoute";

// Login Module
import Login from "../pages/Login";
import RedefinicaoSenha from "../pages/RedefinicaoSenha";
import EsqueciSenha from "../pages/EsqueciSenha";

// Transportadora Module
import TransportadoraVeiculo from '../pages/Transportadora/Cadastro/Veiculos';
import TransportadoraOperacaoPortoAgendada from '../pages/Transportadora/OperacoesPorto/OperacoesPortoAgendada';
import TransportadoraOperacaoPortoCarrossel from '../pages/Transportadora/OperacoesPorto/OperacoesPortoCarrossel';
import TransportadoraOperacaoPatioTriagens from '../pages/Transportadora/OperacoesPatio/Triagens/index.jsx';

// Patio Module
import OperacoesPatioEntradaVeiculos from "../pages/Patio/OperacoesPatio/OperacoesPatioEntradaVeiculos";
import ListOperacoesPatioServicos from "../pages/Patio/OperacoesPatio/OperacoesPatioServicos";
import ListOperacoesPatioFaturamento from "../pages/Patio/OperacoesPatio/OperacoesPatioFaturamento";
import ListOperacoesPatioGuiches from "../pages/Patio/OperacoesPatio/OperacoesPatioGuiches";
import PainelChamadas from "../pages/Patio/OperacoesPatio/OperacoesPatioPainelChamadas";
import PainelChamadasBoard from "../pages/Patio/OperacoesPatio/OperacoesPatioPainelChamadas/Board";
import ListOperacoesPatioGuichesMovimentacao from "../pages/Patio/OperacoesPatio/OperacoesPatioGuichesMovimentacao";
import ListOperacoesPatioCancelas from "../pages/Patio/OperacoesPatio/OperacoesPatioCancelas";
import CancelaManual from "../pages/Patio/OperacoesPatio/CancelaManual";
import CancelaManualSPE from "../pages/Patio/OperacoesPatio/CancelaManualSPE";
import Triagens from "../pages/Patio/OperacoesPatio/Triagens/index.jsx";
import OperacoesPatioSPE from "../pages/Patio/OperacoesPatio/OperacoesPatioSPE";
import OperacoesPatioEntradaSaidaVeiculosSPE from "../pages/Patio/OperacoesPatio/OperacoesPatioEntradaSaidaVeiculosSPE";
import OperacoesPortoAgendada from "../pages/Patio/OperacoesPorto/OperacoesPortoAgendada";
import OperacoesPortoAgendadaSPE from "../pages/Patio/OperacoesPorto/OperacoesPortoAgendadaSPE";
import Transportadoras from "../pages/Patio/Cadastro/Transportadoras";
import ProprietarioCargas from "../pages/Patio/Cadastro/ProprietarioCargas";
import CustoTriagem from "../pages/Patio/Comercial/CustoTriagem/index.js";
import CustoEstadia from "../pages/Patio/Comercial/CustoEstadia/index.js";
import Bumerangue from "../pages/Patio/Comercial/Bumerangue/index.js";
import PatioPortoAudit from "../pages/Patio/Auditoria/PatioPorto";
import OperacoesPortoCarrossel from "../pages/Patio/OperacoesPorto/OperacoesPortoCarrossel/index.js";
import EntradaVeiculosAudit from "../pages/Patio/Auditoria/EntradaVeiculos";
import TerminalPatioAudit from "../pages/Patio/Auditoria/TerminalPatio";
import CaixaGeral from "../pages/Patio/Financeiro/CaixaGeral";
import Faturamento from "../pages/Patio/Financeiro/Faturamento";
import Movimentacoes from "../pages/Patio/Financeiro/Movimentações";
import PowerBI from "../pages/Patio/Indicadores/PowerBI";
import ListVeiculo from "../pages/Patio/Cadastro/Veiculos/index.js";
import ListMotorista from "../pages/Patio/Cadastro/Motoristas/index.js";
import ListMensalista from "../pages/Patio/Cadastro/Mensalista/index.js";
import ListTipoServico from "../pages/Patio/Configuracoes/TipoServico";
import TipoCargaSPE from "../pages/Patio/Configuracoes/TipoCargaSPE/index.js";
import ListValidacaoCRLV from "../pages/Patio/Configuracoes/ValidacaoCRLV/index.js";
import ListParametros from "../pages/Patio/Configuracoes/Parametros/index.js";
import ListUsuario from "../pages/Patio/Configuracoes/Usuario/index.js";
import ListGrupos from "../pages/Patio/Configuracoes/Grupos/index.js";
import Terminal from "../pages/Patio/Cadastro/Terminal/index.js";

/**
 * `router` is a configuration object used to define the routes for a React application, utilizing the `createBrowserRouter` function.
 * This configuration includes multiple routes corresponding to different paths and their respective components. Some routes are wrapped with
 * a `PrivateRoute` component to restrict access to authenticated users.
 *
 * Route definitions:
 * - `/`: Displays the `Login` component.
 * - `/redefinicaoSenha`: Displays the `RedefinicaoSenha` component.
 * - `/cadastros/veiculos`: Protected route displaying `ListVeiculo` for authenticated users.
 * - `/cadastros/motoristas`: Protected route displaying `ListMotorista` for authenticated users.
 * - `/cadastros/transportadoras`: Protected route displaying `Transportadoras` for authenticated users.
 * - `/cadastros/motoristas/adicionar`: Protected route displaying `ListMotorista` for authenticated users when adding drivers.
 * - `/cadastros/mensalistas`: Protected route displaying `ListMensalista`.
 * - `/cadastros/terminais`: Protected route displaying the `Terminal` component.
 * - `/operacoes_patio/servicos`: Protected route displaying `ListOperacoesPatioServicos`.
 * - `/configuracoes/tipos_servicos`: Protected route displaying `ListTipoServico`.
 * - `/operacoes_patio/entrada_saida_veiculos`: Protected route displaying `OperacoesPatioEntradaVeiculos`.
 * - `/operacoes_patio/triagens`: Protected route displaying `Triagens`.
 * - `/operacoes_porto/agendada`: Protected route displaying `OperacoesPortoAgendada`.
 * - `/operacoes_patio/faturamento`: Protected route displaying `ListOperacoesPatioFaturamento`.
 *
 * Components wrapped with `PrivateRoute` indicate that user authentication is required to access those routes.
 */
const router = createBrowserRouter([
  /** Login Module
   * 
   * Routes related to user authentication and password management.
   */
  {
    path: '',
    element: (
      <Route>
        <Login />
      </Route>
    )
  },
  {
    path: '/redefinicaoSenha',
    element: (
      <Route>
        <RedefinicaoSenha />
      </Route>
    )
  },
  {
    path: '/esqueci-senha',
    element: (
      <Route>
        <EsqueciSenha />
      </Route>
    )
  },

  /**
   *  Patio Module
   * 
   * Routes related to patio operations, configurations, and audits.
   */
  {
    path: '/patio/cadastros/veiculos',
    element: (
      <PrivateRoute>
        <ListVeiculo />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/cadastros/motoristas',
    element: (
      <PrivateRoute>
        <ListMotorista />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/cadastros/transportadoras',
    element: (
      <PrivateRoute>
        <Transportadoras />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/cadastros/proprietarios_carga',
    element: (
      <PrivateRoute>
        <ProprietarioCargas />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/cadastros/motoristas/adicionar',
    element: (
      <PrivateRoute>
        <ListMotorista />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/cadastros/mensalistas',
    element: (
      <PrivateRoute>
        <ListMensalista />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/cadastros/terminais',
    element: (
      <PrivateRoute>
        <Terminal />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/comercial/custo_triagem',
    element: (
      <PrivateRoute>
        <CustoTriagem />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/comercial/custo_estadia',
    element: (
      <PrivateRoute>
        <CustoEstadia />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/comercial/bumerangue',
    element: (
      <PrivateRoute>
        <Bumerangue />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/financeiro/caixa_geral',
    element: (
      <PrivateRoute>
        <CaixaGeral />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/financeiro/faturamento',
    element: (
      <PrivateRoute>
        <Faturamento />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/financeiro/movimentacoes',
    element: (
      <PrivateRoute>
        <Movimentacoes />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/servicos',
    element: (
      <PrivateRoute>
        <ListOperacoesPatioServicos />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/faturamento',
    element: (
      <PrivateRoute>
        <ListOperacoesPatioFaturamento />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/guiches',
    element: (
      <PrivateRoute>
        <ListOperacoesPatioGuiches />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/painel_chamadas',
    element: (
      <PrivateRoute>
        <PainelChamadas />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/painel_chamadas/board',
    element: <PainelChamadasBoard />
  },
  {
    path: '/operacoes_patio/guiches/movimentacoes',
    element: (
      <PrivateRoute>
        <ListOperacoesPatioGuichesMovimentacao />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/cancelas',
    element: (
      <PrivateRoute>
        <ListOperacoesPatioCancelas />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/cancela_manual',
    element: (
      <PrivateRoute>
        <CancelaManual />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/cancela_manual_spe',
    element: (
      <PrivateRoute>
        <CancelaManualSPE />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/configuracoes/tipos_servicos',
    element: (
      <PrivateRoute>
        <ListTipoServico />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/configuracoes/tipos_carga_spe',
    element: (
      <PrivateRoute>
        <TipoCargaSPE />
      </PrivateRoute>
    )
  },

  {
    path: '/patio/operacoes_patio/entrada_saida_veiculos',
    element: (
      <PrivateRoute>
        <OperacoesPatioEntradaVeiculos />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/entrada_saida_veiculos_spe',
    element: (
      <PrivateRoute>
        <OperacoesPatioEntradaSaidaVeiculosSPE />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/triagens',
    element: (
      <PrivateRoute>
        <Triagens />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_porto/agendada',
    element: (
      <PrivateRoute>
        <OperacoesPortoAgendada />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_porto/agendada_spe',
    element: (
      <PrivateRoute>
        <OperacoesPortoAgendadaSPE />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_patio/spe',
    element: (
      <PrivateRoute>
        <OperacoesPatioSPE />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/operacoes_porto/carrossel',
    element: (
      <PrivateRoute>
        <OperacoesPortoCarrossel />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/auditoria/patio_porto',
    element: (
      <PrivateRoute>
        <PatioPortoAudit />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/auditoria/entrada_veiculos',
    element: (
      <PrivateRoute>
        <EntradaVeiculosAudit />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/auditoria/terminal_patio',
    element: (
      <PrivateRoute>
        <TerminalPatioAudit />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/configuracoes/validacao_crlv',
    element: (
      <PrivateRoute>
        <ListValidacaoCRLV />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/configuracoes/parametros',
    element: (
      <PrivateRoute>
        <ListParametros />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/configuracoes/usuarios',
    element: (
      <PrivateRoute>
        <ListUsuario />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/configuracoes/grupos',
    element: (
      <PrivateRoute>
        <ListGrupos />
      </PrivateRoute>
    )
  },
  {
    path: '/patio/indicadores/powerbi',
    element: (
      <PrivateRoute>
        <PowerBI />
      </PrivateRoute>
    )
  },

  /**
   *  Transportadora Module
   * 
   * Routes related to carrier (transportadora) operations.
   */
  {
    path: '/transportadora/cadastros/veiculos',
    element: (
      <PrivateRoute>
        <TransportadoraVeiculo />
      </PrivateRoute>
    )
  },
  {
    path: '/transportadora/operacoes_porto/agendada',
    element: (
      <PrivateRoute>
        <TransportadoraOperacaoPortoAgendada />
      </PrivateRoute>
    )
  },
  {
    path: '/transportadora/operacoes_porto/carrossel',
    element: (
      <PrivateRoute>
        <TransportadoraOperacaoPortoCarrossel />
      </PrivateRoute>
    )
  },
  {
    path: '/transportadora/operacoes_patio/triagens',
    element: (
      <PrivateRoute>
        <TransportadoraOperacaoPatioTriagens />
      </PrivateRoute>
    )
  },
]);

export default router;